import React from 'react'
import moment from 'moment'
import {
  DateRangePickerComponent,
  PresetsDirective,
  PresetDirective,
} from '@syncfusion/ej2-react-calendars'

import './DateRangePickerStyle.css'

export type DateRangePickerProps = {
  className?: string
  width?: string
  showClearButton?: boolean
  openOnFocus?: boolean
  dateRange: { start: Date; end: Date }
  handleDateRangeChange: (start: Date, end: Date) => void
  showDateBtn: boolean
  allowEdit?: boolean
}

const DateRangePicker = React.forwardRef<
  DateRangePickerComponent,
  DateRangePickerProps
>(function DateRangePicker(
  {
    className,
    width,
    showClearButton,
    openOnFocus,
    dateRange,
    handleDateRangeChange,
    showDateBtn,
    allowEdit,
  },
  ref,
) {
  // This Week
  const weekStart = moment().startOf('week').toDate()
  const weekEnd = moment().startOf('week').add(6, 'days').toDate()
  // Last Week
  const lastWeekStart = moment().subtract(1, 'week').startOf('week').toDate()
  const lastWeekEnd = moment()
    .subtract(1, 'week')
    .startOf('week')
    .add(6, 'days')
    .toDate()
  // Next Week
  const nextWeekStart = moment().add(1, 'week').startOf('week').toDate()
  const nextWeekEnd = moment()
    .add(1, 'week')
    .startOf('week')
    .add(6, 'days')
    .toDate()

  const toggleDateChange = (e: any): void => {
    if (e.startDate && e.endDate) {
      handleDateRangeChange(e.startDate, e.endDate)
    } else {
      handleDateRangeChange(
        moment().startOf('week').toDate(),
        moment().startOf('week').add(6, 'days').toDate(),
      )
    }
  }

  return (
    <div className="control-pane">
      <div className="control-section">
        <div
          className={`custom-date-range ${className || 'calendar-control-section'}`}
        >
          <DateRangePickerComponent
            ref={ref}
            placeholder="Select a range"
            value={[dateRange.start, dateRange.end]}
            change={toggleDateChange}
            format="MMMM dd, yyyy"
            width={width ?? '200'}
            showClearButton={showClearButton ?? true}
            openOnFocus={openOnFocus}
            allowEdit={allowEdit}
          >
            {showDateBtn && (
              <PresetsDirective>
                <PresetDirective
                  label="This Week"
                  start={weekStart}
                  end={weekEnd}
                />
                <PresetDirective
                  label="Last Week"
                  start={lastWeekStart}
                  end={lastWeekEnd}
                />
                <PresetDirective
                  label="Next Week"
                  start={nextWeekStart}
                  end={nextWeekEnd}
                />
              </PresetsDirective>
            )}
          </DateRangePickerComponent>
        </div>
      </div>
    </div>
  )
})

DateRangePicker.displayName = 'DateRangePicker'

export default DateRangePicker
